import { render, staticRenderFns } from "./PaginatedFileList.vue?vue&type=template&id=6d7a4012&"
import script from "./PaginatedFileList.vue?vue&type=script&lang=js&"
export * from "./PaginatedFileList.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedFileList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports